import { connect } from 'react-redux';

import PortCancel from './PortCancel';
import { portCancel } from 'actions/subs';
import { getSubmitStatus, getSubmitSucceeded, getIsAdmin } from 'reducers';
import subPage from 'decorators/subPage';

const mapStateToProps = (state) => ({
  saveStatus: getSubmitStatus(state, 'portCancel'),
  submitSucceeded: getSubmitSucceeded(state, 'portCancel'),
  isAdmin: getIsAdmin(state),
  onSuccessRedirectUrl: (id) => `/subscriptions/${id}/view`,
});

const mapDispatchToProps = (dispatch, { subId }) => ({
  onSubmit: (values) => dispatch(portCancel(subId, values)),
});

export default subPage(
  connect(mapStateToProps, mapDispatchToProps)(PortCancel),
);
